import { Home, X, Share2 } from 'lucide-react';
import usePWAInstall from './usePWAInstall';

const PWAInstallBanner = () => {
  const { install, showBanner, dismissBanner, installPrompt } = usePWAInstall();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 z-50 animate-slide-up">
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
          <Home className="w-6 h-6 text-blue-600" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 text-sm">Instalar IMOCODE</h3>
          <p className="text-gray-500 text-xs mt-0.5">
            {isIOS 
              ? 'Toque em "Partilhar" e depois "Adicionar ao ecrã principal"'
              : 'Instale a app para acesso rápido e notificações'
            }
          </p>
        </div>
        <button onClick={dismissBanner} className="p-1 text-gray-400 hover:text-gray-600">
          <X className="w-5 h-5" />
        </button>
      </div>
      {!isIOS && installPrompt && (
        <button
          onClick={install}
          className="w-full mt-3 bg-blue-600 text-white py-2.5 rounded-xl text-sm font-medium hover:bg-blue-700 transition"
        >
          Instalar Agora
        </button>
      )}
      {isIOS && (
        <div className="mt-3 flex items-center justify-center gap-2 text-blue-600 text-xs">
          <Share2 className="w-4 h-4" />
          <span>Partilhar → Adicionar ao ecrã principal</span>
        </div>
      )}
    </div>
  );
};

export default PWAInstallBanner;
